import React from 'react';

function BookingModal({ show, instance, form, setForm, success, onSubmit, onClose, formatDate, formatPrice }) {
  if (!show || !instance) return null;

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>
          {instance.availability !== 'full'
            ? `Boka plats - ${instance.course?.name || instance.courseName}`
            : `Väntelista - ${instance.course?.name || instance.courseName}`
          }
        </h2>

        <div className="booking-info">
          <p>📅 {formatDate(instance.startDate)}</p>
          <p>📍 {instance.location || instance.venue?.name}</p>
          <p>💰 {formatPrice(
            instance.price || instance.course?.price,
            instance.earlyBirdDiscount
          )}</p>
        </div>

        {success ? (
          <div className="success-message">{success}</div>
        ) : (
          <form onSubmit={onSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="participantFirstName"
                placeholder="Förnamn *"
                value={form.participantFirstName}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="participantLastName"
                placeholder="Efternamn *"
                value={form.participantLastName}
                onChange={handleInputChange}
                required
              />
            </div>

            <input
              type="email"
              name="participantEmail"
              placeholder="E-post *"
              value={form.participantEmail}
              onChange={handleInputChange}
              required
              className="full-width"
            />

            <div className="form-row">
              <input
                type="tel"
                name="participantPhone"
                placeholder="Telefon"
                value={form.participantPhone}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="company"
                placeholder="Företag *"
                value={form.company}
                onChange={handleInputChange}
                required
              />
            </div>

            <input
              type="text"
              name="invoiceReference"
              placeholder="Fakturareferens/kostnadsställe"
              value={form.invoiceReference}
              onChange={handleInputChange}
              className="full-width"
            />

            <textarea
              name="specialDiet"
              placeholder="Allergier eller specialkost"
              value={form.specialDiet}
              onChange={handleInputChange}
              rows="2"
              className="full-width"
            />

            <div className="form-actions">
              <button type="submit" className="btn btn-success">
                {instance.availability !== 'full'
                  ? 'Bekräfta bokning'
                  : 'Ställ mig på väntelista'
                }
              </button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Avbryt
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default BookingModal;
